export enum ReportsSortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}
